import { Injectable } from '@angular/core';
import { isAfter, isBefore } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class SortUtilityService {
  public sortOrdered<T>(a: T, b: T, order: T[]): -1 | 0 | 1 {
    const aIndex = order.indexOf(a);
    const bIndex = order.indexOf(b);
    if (aIndex < bIndex) {
      return -1;
    } else if (aIndex > bIndex) {
      return 1;
    }
    return 0;
  }

  public sortDate(
    a: string | Date,
    b: string | Date,
    direction: 'asc' | 'desc' = 'asc'
  ): -1 | 0 | 1 {
    const aMoment = new Date(a);
    const bMoment = new Date(b);
    if (isBefore(aMoment, bMoment)) {
      return direction === 'asc' ? -1 : 1;
    } else if (isAfter(aMoment, bMoment)) {
      return direction === 'asc' ? 1 : -1;
    }
    return 0;
  }
}
